import { defineMessages } from 'react-intl';

type MessageKeys = 'expand' | 'collapse';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		expand: {
			id: 'ai-mate.common.ui.expandable-section.expand',
			defaultMessage: 'Expand',
			description:
				'Button label or action text displayed on a button or clickable element in an expandable section within the AI conversation interface that expands to show more content. Shown as clickable text on an expand/collapse control. When clicked, it expands the section to reveal its full content. The purpose is to allow users to view additional content when it has been collapsed to save screen space.',
		},
		collapse: {
			id: 'ai-mate.common.ui.expandable-section.collapse',
			defaultMessage: 'Collapse',
			description:
				'Button label or action text displayed on a button or clickable element in an expanded section within the AI conversation interface that collapses to hide content. Shown as clickable text on an expand/collapse control. When clicked, it collapses the section to hide its content and show only a summary. The purpose is to allow users to minimize sections to save screen space and reduce visual clutter.',
		},
	});

export default message;
